// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import * as moment from "moment";
import * as L from "leaflet";

export const domain = {
  // apiUrl: "https://vamavideotest.herokuapp.com/api/v1",
  // baseUrl: "http://localhost:4200",
  // apiUrl: "http://localhost:3309/api/v1",
  baseUrl: "http://167.235.137.165",
  // apiUrl: "http://167.235.137.165:3309/api/v1",
  apiUrl: "http://api.icvsmanager.fedweb.es/api/v1",
};

export const icons = {
  iconRetinaUrl: "assets/img/icons/marker-icon.svg",
  iconUrl: "assets/img/icons/marker-icon.svg",
  iconUrlCar: "assets/img/icons/car-icon.png",
  iconUrlCarOnline: "assets/img/icons/car-icon.png",
  iconUrlCarOffline: "assets/img/icons/car-icon-red.png",
  iconUrlIncidentCar: "assets/img/icons/incidentcar-icon.png",
  iconImageDefaultVideo: "assets/img/logos/logo-vama.png",
};

export const patterns = {
  phonePattern: /^(\+)[0-9]{3}[0-9]{8,}$/,
  emailPattern: "^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$",
  portPattern: /^(0|[1-9]\d{0,4}|[1-5]\d{4}|6[0-4]\d{3}|65000)$/,
};

export const devicesKeys = {
  secretKey: "65731BFEBC8196570EF3EC921EC46A38",
  ivKey: "5F71B6EF09A4C7F5FECA54D2E3FA86BB",
  algorithm: [
    {
      id: 1,
      value: "128-bit AES, CBC",
    },
  ],
  padding: [
    {
      id: 1,
      value: "PKCS7-padded",
    },
  ],
};

export const configMaps = {
  iconsDefault: L.icon({
    iconUrl: icons.iconUrlCar,
    iconSize: [20, 20],
    iconAnchor: [12, 12],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [68, 95],
    shadowAnchor: [22, 94],
  }),

  iconsDefaultOnline: L.icon({
    iconUrl: icons.iconUrlCarOnline,
    iconSize: [20, 20],
    iconAnchor: [12, 12],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [68, 95],
    shadowAnchor: [22, 94],
  }),

  iconsDefaultOffline: L.icon({
    iconUrl: icons.iconUrlCarOffline,
    iconSize: [20, 20],
    iconAnchor: [12, 12],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [68, 95],
    shadowAnchor: [22, 94],
  }),

  mapDefault: {
    minZoom: 2,
    maxZoom: 19,
  },
  mapDefaultDetail: {
    minZoom: 2,
    maxZoom: 19,
  },
  zoomMapDefault: 3,
  zoomMapDefaultDetail: 3,

  polylineDefault: {
    color: "grey",
    opacity: 0.9,
    weight: 2.5,
  },
  circleDefault: {
    color: "red",
    fillColor: "#f03",
    fillOpacity: 0.5,
    radius: 500,
  },
};

export const environment = {
  production: false,

  loginUrlApi: domain.apiUrl + "/auth/login",
  logoutUrlApi: domain.apiUrl + "/auth/logout",

  userDomainUrlApi: domain.apiUrl + "/user-domain",
  userPermissionsUrlApi: domain.apiUrl + "/user-permissions",
  userViewPermissionsUrlApi: domain.apiUrl + "/user-view-permissions",

  recoveryPasswordSendMailUrlApi: domain.apiUrl + "/recovery/password",
  recoveryPasswordUrlApi: domain.apiUrl + "/recovery/password",

  adminAccessUrlApi: domain.apiUrl + "/admin-access",
  adminResetPass: domain.apiUrl + "/admin-access/resetpass",

  dashboardUrlApi: domain.apiUrl + "/dashboard",

  clientsUrlApi: domain.apiUrl + "/client",
  clientsWithFiltersUrlApi: domain.apiUrl + "/client-datatables",
  blockUnblockClientById: domain.apiUrl + "/client/active",

  clientUserByClient: domain.apiUrl + "/client-user-by-client",

  usersAdminUrlApi: domain.apiUrl + "/client-user",
  usersAdminWithFiltersUrlApi: domain.apiUrl + "/client-user-datatables",
  blockUnblockUserAdminById: domain.apiUrl + "/client-user/active",

  usersNoAdminUrlApi: domain.apiUrl + "/client-user-noadmin",
  usersNoAdminWithFiltersUrlApi:
    domain.apiUrl + "/client-user-noadmin-datatables",
  blockUnblockClientUserNoAdminById:
    domain.apiUrl + "/client-user-noadmin/active",

  loginAdminToClientUrlApi: domain.apiUrl + "/auth/loginAdminToClient",
  logoutAdminToClientUrlApi: domain.apiUrl + "/auth/logoutAdminToClient",

  groupsUrlApi: domain.apiUrl + "/group",
  groupsListlUrlApi: domain.apiUrl + "/group/list",
  groupsAssignRolesUrlApi: domain.apiUrl + "/group/role",
  groupsWithFiltersUrlApi: domain.apiUrl + "/group-datatables",
  groupsByUserUrlApi: domain.apiUrl + "/users/groups",

  rolesUrlApi: domain.apiUrl + "/role",
  rolesListUrlApi: domain.apiUrl + "/role/list",
  rolesWithFiltersUrlApi: domain.apiUrl + "/role-datatables",
  rolessAssignPermissionsUrlApi: domain.apiUrl + "/role/permissions",
  rolesByUserUrlApi: domain.apiUrl + "/users/roles",

  rolesViewPermissionListUrlApi:
    domain.apiUrl + "/master-role-view-permissions",
  rolesGetViewPermissionUrlApi: domain.apiUrl + "/role-view-permissions",
  rolesAssignViewPermissionUrlApi: domain.apiUrl + "/role-view-permissions",

  usersUrlApi: domain.apiUrl + "/users",
  userUrlApi: domain.apiUrl + "/user",
  blockUnblockUserById: domain.apiUrl + "/user/active",
  userAssignGroupsUrlApi: domain.apiUrl + "/user/groups",
  userAssignRolesUrlApi: domain.apiUrl + "/user/roles",

  policeStationsUrlApi: domain.apiUrl + "/police-stations",

  policeStationsDevicesUrlApi: domain.apiUrl + "/police-stations-devices",

  //TODO
  userAssignPoliceStationToUserUrlApi: domain.apiUrl + "/devices/user",

  systemPoliciesUrlApi: domain.apiUrl + "/globals",

  permissionsUrlApi: domain.apiUrl + "/permissions",
  permissionsByRoleUrlApi: domain.apiUrl + "/role/permissions",

  videosUrlApi: domain.apiUrl + "/videos",
  videoUrlApi: domain.apiUrl + "/video",
  videoMetadataUrlApi: domain.apiUrl + "/video-metadata",
  videosOwnerUrlApi: domain.apiUrl + "/videos-owner",
  videosWithFiltersUrlApi: domain.apiUrl + "/videos-datatables",
  videosPlayUrlApi: domain.apiUrl + "/video/play",
  videosgetPosterVideoUrlApi: domain.apiUrl + "/video/frame",
  enableVideoPosterRequests: true,
  videosCheckVideoUrlApi: domain.apiUrl + "/videos/check",
  videosDownloadVideoUrlApi: domain.apiUrl + "/video/downloadVideo",

  videosSharedUrlApi: domain.apiUrl + "/videos/shared",
  videosMySharedListUrlApi: domain.apiUrl + "/videos/shared/list",
  videosMySharedOwnerListUrlApi: domain.apiUrl + "/videos/shared/owner",

  videosBookmarksCheckUnCheckListUrlApi: domain.apiUrl + "/videos/bookmark",
  videosBookmarksListUrlApi: domain.apiUrl + "/videos-bookmark",

  videosBlockUnBlockListUrlApi: domain.apiUrl + "/videos/block",

  videoOwnFootagesByIncidentUrlApi: domain.apiUrl + "/footage-incident-own",
  videoFootagesPlayUrlApi: domain.apiUrl + "/footage/play",
  videoFootagesgetPosterFootageUrlApi: domain.apiUrl + "/footage/frame",

  videoFootageUrlApi: domain.apiUrl + "/footage",
  videoFootagesByUserUrlApi: domain.apiUrl + "/footage-user",
  videoFootagesByVideoUrlApi: domain.apiUrl + "/footage-video",
  videoFootagesByIncidentUrlApi: domain.apiUrl + "/footage-incident",
  videoFootagesByIncidentandUserUrlApi:
    domain.apiUrl + "/footage-incident-user",

  videoFootagesSharedUrlApi: domain.apiUrl + "",
  videoFootagesMySharedListUrlApi: domain.apiUrl + "",

  videoFootagesBookmarksCheckUnCheckListUrlApi: domain.apiUrl + "",
  videoFootagesBookmarksListUrlApi: domain.apiUrl + "",

  gpsOneVideoUrlApi: domain.apiUrl + "/gps", //no

  gpsTacticalMapUrlApi: domain.apiUrl + "/gps-tactical",
  gpsTacticalMapDevicesUrlApi: domain.apiUrl + "/gps-devices",

  gpsAllIncidentsUrlApi: domain.apiUrl + "/gps-all-incidents",

  gpsOneFootageUrlApi: domain.apiUrl + "/gps-one-footage",

  gpsFake: domain.apiUrl + "/gps-fake",

  incidentsListUrlApi: domain.apiUrl + "/incidents-list",
  incidentsUrlApi: domain.apiUrl + "/incidents",
  incidentsOwnerUrlApi: domain.apiUrl + "/incidents-owner",
  incidentsWithFiltersUrlApi: domain.apiUrl + "/incidents-datatables",

  incidentsSharedUrlApi: domain.apiUrl + "/incidents/shared",
  incidentMySharedListUrlApi: domain.apiUrl + "/incidents/shared/list",
  incidentMySharedOwnListUrlApi: domain.apiUrl + "/incidents/shared/owner",

  incidentsVideosUrlApi: domain.apiUrl + "/incidents/videos",
  incidentsVideosListUrlApi: domain.apiUrl + "/incidents/videos/list",

  incidentsBookmarksCheckUnCheckListUrlApi:
    domain.apiUrl + "/incidents/bookmark",
  incidentsBookmarksListUrlApi: domain.apiUrl + "/incidents-bookmark",

  collectionsUrlApi: domain.apiUrl + "/collections",
  collectionsOwnerUrlApi: domain.apiUrl + "/collections-owner",
  collectionsListUrlApi: domain.apiUrl + "/collections/list",

  collectionIncidentUrlApi: domain.apiUrl + "/collection/incident",

  masterClustersUrlApi: domain.apiUrl + "/master-cluster",

  masterFtpTestUrlApi: domain.apiUrl + "/client/test-ftp",
  masterFtpCreateUrlApi: domain.apiUrl + "/client/create-ftp",

  masterIncidentDestinationUrlApi:
    domain.apiUrl + "/master/incidents/destination",
  masterIncidentMotivationUrlApi:
    domain.apiUrl + "/master/incidents/motivation",
  masterIncidentReasonUrlApi: domain.apiUrl + "/master/incidents/reason",
  masterIncidentStatusUrlApi: domain.apiUrl + "/master/incidents/status",

  getCollectionsListIncidentExcluded:
    domain.apiUrl + "/collections/list-incident-exluded",

  getUsersListVideoSharedExcluded: domain.apiUrl + "/videos/shared/list-users",
  getUsersListIncidentSharedExcluded:
    domain.apiUrl + "/incidents/shared/list-users",

  storageTokenNameApi: "token",
  storageTypeUserNameApi: "typeUser",
  storageIdUserNameApi: "id",
  storageLanguageNameApi: "lang",
  storageUsernameNameApi: "username",
  storageUserPermissionsNameApi: "permissions",
  storageUserViewPermissionsNameApi: "viewPermissions",
  storageLastRouteNameApi: "lastRoute",
  storageUseExternalRecorderNameApi: "useExternalRecorder",

  devicesUrlApi: domain.apiUrl + "/devices",
  devicesNotAssignedUrlApi: domain.apiUrl + "/devices-not-assigned",
  devicesAliveUrlApi: domain.apiUrl + "/devices-alive",
  devicesWithFiltersUrlApi: domain.apiUrl + "/devices-datatables",
  devicesOwnUrlApi: domain.apiUrl + "/devices-own",
  devicesUserUrlApi: domain.apiUrl + "/devices/user",
  userAssignDevicesToMeUrlApi: domain.apiUrl + "/devices/own",
  userAssignDevicesToUserUrlApi: domain.apiUrl + "/devices/user",
  //TODO
  devicescheckSettingsDeviceUrlApi: domain.apiUrl + "/",

  videoRecordFunctionsHelloUrlApi: domain.apiUrl + "/vm/functions/hello",
  videoRecordFunctionsGetUsersUrlApi: domain.apiUrl + "/vm/functions/getUsers",
  videoRecordFunctionsGetRegisterInfoUrlApi:
    domain.apiUrl + "/vm/functions/getRegisterInfo",
  videoRecordFunctionsGetVersionInfoUrlApi:
    domain.apiUrl + "/vm/functions/getVersionInfo",
  videoRecordFunctionsGetCameraInfoUrlApi:
    domain.apiUrl + "/vm/functions/getCameraInfo",
  videoRecordFunctionsShutdownUrlApi: domain.apiUrl + "/vm/functions/shutdown",
  videoRecordFunctionsLogoutUrlApi: domain.apiUrl + "/vm/functions/logout",
  videoRecordFunctionsGetRecordDaysUrlApi:
    domain.apiUrl + "/vm/functions/getRecordDays",

  videoRecordFunctionsGetDownloadVideoSizeUrlApi:
    domain.apiUrl + "/vm/functions/getDownloadVideoSize",
  videoRecordFunctionsQueryFileListUrlApi:
    domain.apiUrl + "/vm/functions/queryFileList",

  videoRecordFunctionsGetConfigValuesUrlApi:
    domain.apiUrl + "/vm/functions/getConfigValues",

  videoRecordFunctionsDownloadVideoUrlApi:
    domain.apiUrl + "/vm/functions/downloadVideo",

  camerasUrlApi: domain.apiUrl + "/cameras",
  cameraUrlApi: domain.apiUrl + "/camera",

  assetsUrlApi: domain.apiUrl + "/asset",
  assetsGetUrlApi: domain.apiUrl + "/test-upload-assets",
  assetsPostUrlApi: domain.apiUrl + "/test-post-assets",
  assetsOwnUrlApi: domain.apiUrl + "/assets-owner-incidents",
  assetsCheckIntegrityUrlApi: domain.apiUrl + "/assets-owner-incidents",

  reportsUrlApi: domain.apiUrl + "/reports",
  reportsWithFiltersUrlApi: domain.apiUrl + "/reports-datatables",
  reportsAuditUrlApi: domain.apiUrl + "/audit",

  statisticsTotalsUrlApi: domain.apiUrl + "/statistics/totals",
  statisticsIncidentsTodayUrlApi: domain.apiUrl + "/statistics/incidents",
  statisticsIncidentsLastMonthUrlApi:
    domain.apiUrl + "/statistics/incidents-last-month",

  notificationsOwnUrlApi: domain.apiUrl + "/notifications-own",
  notificationsMarkReadedUrlApi: domain.apiUrl + "/notifications/readed",

  videoExtensionsListUrlApi: domain.apiUrl + "/videos-extensions",
  assetsExtensionsListUrlApi: domain.apiUrl + "/assets-extensions",

  systemReportMailtUrlApi: domain.apiUrl + "/system-report",
  systemVideoRecordLogsUrlApi: domain.apiUrl + "/vr/logs",

  modalsTranslatesEs: {
    yes: "Si",
    youWontBeAbleRevert: "¡No podrás revertir esto!",
    areYouSureDelete: "Estás seguro de eliminar",
    areYouSureOverwrite: "Estás seguro de sobreescribir",
    yourSessionHasExpired: "Tu sesión ha expirado",
    login: "Login",
    error: "Error",
    timeoutHasOccurred: "Se agotó el tiempo de espera",
    passwordChanged: "Contraseña cambiada",
    youPasswordHaveBeenChanged:
      "Su contraseña ha sido cambiada satisfactoriamente",
  },

  modalsTranslatesEn: {
    yes: "Yes",
    youWontBeAbleRevert: "You won't be able to revert this!",
    areYouSureDelete: "Are you sure delete",
    areYouSureOverwrite: "Are you sure overwrite",
    yourSessionHasExpired: "Your session has expired",
    login: "Login",
    error: "Error",
    timeoutHasOccurred: "Timeout has occurred",
    passwordChanged: "Password changed",
    youPasswordHaveBeenChanged: "Your password have been changed successfully",
  },

  dtOptionsDatatablesEs: {
    responsive: true,
    pagingType: "full_numbers",
    pageLength: 10,
    stateSave: false,
    paging: true,
    searching: true,
    destroy: true,
    language: {
      url: "assets/i18n/datatables/es.json",
    },
    dom: "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>><'row'<'col-sm-12 col-md-5'B>>",

    // Configure the buttons
    buttons: [
      // "selectAll",
      // "selectNone",
      // "colvis",
      // "copy",
      // "print",
      // "selectAll",
      {
        extend: "excelHtml5",
        title: function () {
          return document.getElementsByTagName("h4")[0].innerText;
        },
        text: '<a data-id="Exportar" class="button-datatable-action btn-sm edit button-excel-datatables toltip toltip--top"></a>',
        titleAttr: "Exportar",
        exportOptions: {
          columns: [":visible:not(:last-child)"],
          format: {
            body: function (data, row, column, node) {
              if (data.includes('title="1"') || data == "true") {
                data = "✔";
              } else if (data.includes('title="0"') || data == "false") {
                data = "✕";
              } else {
                var div = document.createElement("div");
                div.innerHTML = data;
                data = div.textContent || div.innerText || "";
              }
              return data;
            },
          },
        },
      },
      {
        extend: "print",
        title: function () {
          return document.getElementsByTagName("h4")[0].innerText;
        },
        text: '<a data-id="Imprimir" class="button-datatable-action btn-sm edit button-print-datatables toltip toltip--top"></a>',
        titleAttr: "Imprimir",
        exportOptions: {
          columns: [":visible:not(:last-child)"],
          format: {
            body: function (data, row, column, node) {
              if (data.includes('title="1"') || data == "true") {
                data = "✔";
              } else if (data.includes('title="0"') || data == "false") {
                data = "✕";
              } else {
                var div = document.createElement("div");
                div.innerHTML = data;
                data = div.textContent || div.innerText || "";
              }

              return data;
            },
          },
        },
      },
      /* {
        text: "Some button",
        key: "1",
        action: function (e, dt, node, config) {
          alert("Button activated");
        }, */
    ],
  },

  dtOptionsDatatablesEn: {
    responsive: true,
    pagingType: "full_numbers",
    pageLength: 10,
    stateSave: false,
    paging: true,
    searching: true,
    destroy: true,
    language: {
      url: "assets/i18n/datatables/en.json",
    },
    dom: "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>><'row'<'col-sm-12 col-md-5'B>>",
    /*   columns: [
      {
        data: "select",
        className: "",
        orderable: false,
        searchable: false,
      },
      { data: "id" },
      { data: "name" },

      { data: "actions", orderable: false, searchable: false },
    ],
    select: {
      style: "multi",
      selector: "td:first-child",
    }, */
    // Configure the buttons
    buttons: [
      // "selectAll",
      // "selectNone",
      // "colvis",
      // "copy",
      // "print",
      // "selectAll",
      {
        extend: "excelHtml5",
        title: function () {
          return document.getElementsByTagName("h4")[0].innerText;
        },
        text: '<a data-id="Export Excel" class="button-datatable-action btn-sm edit button-excel-datatables toltip toltip--top"></a>',
        titleAttr: "Export Excel",
        exportOptions: {
          columns: [":visible:not(:last-child)"],
          format: {
            body: function (data, row, column, node) {
              if (data.includes('title="1"') || data == "true") {
                data = "✔";
              } else if (data.includes('title="0"') || data == "false") {
                data = "✕";
              } else {
                var div = document.createElement("div");
                div.innerHTML = data;
                data = div.textContent || div.innerText || "";
              }

              return data;
            },
          },
        },
      },
      {
        extend: "print",
        title: function () {
          return document.getElementsByTagName("h4")[0].innerText;
        },
        text: '<a data-id="Print" class="button-datatable-action btn-sm edit button-print-datatables toltip toltip--top"></a>',
        titleAttr: "Print",
        exportOptions: {
          columns: [":visible:not(:last-child)"],
          format: {
            body: function (data, row, column, node) {
              if (data.includes('title="1"') || data == "true") {
                data = "✔";
              } else if (data.includes('title="0"') || data == "false") {
                data = "✕";
              } else {
                var div = document.createElement("div");
                div.innerHTML = data;
                data = div.textContent || div.innerText || "";
              }

              return data;
            },
          },
        },
      },
      /* {
        text: "Some button",
        key: "1",
        action: function (e, dt, node, config) {
          alert("Button activated");
        }, */
    ],
  },

  dtOptionsDatatablesVideosEn: {
    responsive: true,
    pagingType: "full_numbers",
    pageLength: 10,
    stateSave: false,
    paging: true,
    searching: true,
    destroy: true,
    language: {
      url: "assets/i18n/datatables/en.json",
    },
    dom: "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>><'row'<'col-sm-12 col-md-5'B>>",
    /*   columns: [
      {
        data: "select",
        className: "",
        orderable: false,
        searchable: false,
      },
      { data: "id" },
      { data: "name" },

      { data: "actions", orderable: false, searchable: false },
    ],
    select: {
      style: "multi",
      selector: "td:first-child",
    }, */
    // Configure the buttons
    buttons: [
      // "selectAll",
      // "selectNone",
      // "colvis",
      // "copy",
      // "print",
      // "selectAll",
      {
        extend: "excelHtml5",
        title: function () {
          return document.getElementsByTagName("h4")[0].innerText;
        },
        text: '<a data-id="Export Excel" class="button-datatable-action btn-sm edit button-excel-datatables toltip toltip--top"></a>',
        titleAttr: "Export Excel",
        exportOptions: {
          columns: [":visible:not(:last-child)"],
          format: {
            body: function (data, row, column, node) {
              if (data.includes('title="1"') || data == "true") {
                data = "✔";
              } else if (data.includes('title="0"') || data == "false") {
                data = "✕";
              } else {
                var div = document.createElement("div");
                div.innerHTML = data;
                data = div.textContent || div.innerText || "";
              }

              return data;
            },
          },
        },
      },
      {
        extend: "print",
        title: function () {
          return document.getElementsByTagName("h4")[0].innerText;
        },
        text: '<a data-id="Print" class="button-datatable-action btn-sm edit button-print-datatables toltip toltip--top"></a>',
        titleAttr: "Print",
        exportOptions: {
          columns: [":visible:not(:last-child)"],
          format: {
            body: function (data, row, column, node) {
              if (data.includes('title="1"') || data == "true") {
                data = "✔";
              } else if (data.includes('title="0"') || data == "false") {
                data = "✕";
              } else {
                var div = document.createElement("div");
                div.innerHTML = data;
                data = div.textContent || div.innerText || "";
              }

              return data;
            },
          },
        },
      },
      /* {
        text: "Some button",
        key: "1",
        action: function (e, dt, node, config) {
          alert("Button activated");
        }, */
    ],
    order: [],
  },

  dtOptionsDatatablesVideosEs: {
    responsive: true,
    pagingType: "full_numbers",
    pageLength: 10,
    stateSave: false,
    paging: true,
    searching: true,
    destroy: true,
    language: {
      url: "assets/i18n/datatables/es.json",
    },
    dom: "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>><'row'<'col-sm-12 col-md-5'B>>",

    // Configure the buttons
    buttons: [
      // "selectAll",
      // "selectNone",
      // "colvis",
      // "copy",
      // "print",
      // "selectAll",
      {
        extend: "excelHtml5",
        title: function () {
          return document.getElementsByTagName("h4")[0].innerText;
        },
        text: '<a data-id="Exportar" class="button-datatable-action btn-sm edit button-excel-datatables toltip toltip--top"></a>',
        titleAttr: "Exportar",
        exportOptions: {
          columns: [":visible:not(:last-child)"],
          format: {
            body: function (data, row, column, node) {
              if (data.includes('title="1"') || data == "true") {
                data = "✔";
              } else if (data.includes('title="0"') || data == "false") {
                data = "✕";
              } else {
                var div = document.createElement("div");
                div.innerHTML = data;
                data = div.textContent || div.innerText || "";
              }

              return data;
            },
          },
        },
      },
      {
        extend: "print",
        title: function () {
          return document.getElementsByTagName("h4")[0].innerText;
        },
        text: '<a data-id="Imprimir" class="button-datatable-action btn-sm edit button-print-datatables toltip toltip--top"></a>',
        titleAttr: "Imprimir",
        exportOptions: {
          columns: [":visible:not(:last-child)"],
          format: {
            body: function (data, row, column, node) {
              if (data.includes('title="1"') || data == "true") {
                data = "✔";
              } else if (data.includes('title="0"') || data == "false") {
                data = "✕";
              } else {
                var div = document.createElement("div");
                div.innerHTML = data;
                data = div.textContent || div.innerText || "";
              }

              return data;
            },
          },
        },
      },
      /* {
        text: "Some button",
        key: "1",
        action: function (e, dt, node, config) {
          alert("Button activated");
        }, */
    ],
    order: [],
  },

  currentFormatDateDatepicker: {
    year: moment().year(),
    month: moment().month() + 1,
    day: moment().date(),
  },

  currentFormatInputTime: moment.utc().format("HH:mm:ss"),

  formatHour: "HH:mm:ss",
  formatDate: "YYYY-mm-DD HH:mm:ss",
  formatOnlyDate: "YYYY-MM-DD",
  formatOnlyDateEn: "YYYY-MM-DD",
  formatOnlyDateEs: "DD-MM-YYYY",
  formatDateEn: "YYYY-MM-dd HH:mm:ss",
  formatDateEs: "dd-MM-YYYY HH:mm:ss",

  videoPlayerEs: {
    Play: "Reproducir",
    "Play Video": "Reproducir Vídeo",
    Pause: "Pausa",
    "Current Time": "Tiempo reproducido",
    Duration: "Duración total",
    "Remaining Time": "Tiempo restante",
    "Stream Type": "Tipo de secuencia",
    LIVE: "DIRECTO",
    Loaded: "Cargado",
    Progress: "Progreso",
    Fullscreen: "Pantalla completa",
    "Non-Fullscreen": "Pantalla no completa",
    Mute: "Silenciar",
    Unmute: "No silenciado",
    "Playback Rate": "Velocidad de reproducción",
    Subtitles: "Subtítulos",
    "subtitles off": "Subtítulos desactivados",
    Captions: "Subtítulos especiales",
    "captions off": "Subtítulos especiales desactivados",
    Chapters: "Capítulos",
    "You aborted the media playback":
      "Ha interrumpido la reproducción del vídeo.",
    "A network error caused the media download to fail part-way.":
      "Un error de red ha interrumpido la descarga del vídeo.",
    "The media could not be loaded, either because the server or network failed or because the format is not supported.":
      "No se ha podido cargar el vídeo debido a un fallo de red o del servidor o porque el formato es incompatible.",
    "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":
      "La reproducción de vídeo se ha interrumpido por un problema de corrupción de datos o porque el vídeo precisa funciones que su navegador no ofrece.",
    "No compatible source was found for this media.":
      "No se ha encontrado ninguna fuente compatible con este vídeo.",
    "Audio Player": "Reproductor de audio",
    "Video Player": "Reproductor de video",
    Replay: "Volver a reproducir",
    "Seek to live, currently behind live":
      "Buscar en vivo, actualmente demorado con respecto a la transmisión en vivo",
    "Seek to live, currently playing live":
      "Buscar en vivo, actualmente reproduciendo en vivo",
    "Progress Bar": "Barra de progreso",
    "progress bar timing: currentTime={1} duration={2}": "{1} de {2}",
    Descriptions: "Descripciones",
    "descriptions off": "descripciones desactivadas",
    "Audio Track": "Pista de audio",
    "Volume Level": "Nivel de volumen",
    "The media is encrypted and we do not have the keys to decrypt it.":
      "El material audiovisual está cifrado y no tenemos las claves para descifrarlo.",
    Close: "Cerrar",
    "Modal Window": "Ventana modal",
    "This is a modal window": "Esta es una ventana modal",
    "This modal can be closed by pressing the Escape key or activating the close button.":
      "Esta ventana modal puede cerrarse presionando la tecla Escape o activando el botón de cierre.",
    ", opens captions settings dialog":
      ", abre el diálogo de configuración de leyendas",
    ", opens subtitles settings dialog":
      ", abre el diálogo de configuración de subtítulos",
    ", selected": ", seleccionado",
    "Close Modal Dialog": "Cierra cuadro de diálogo modal",
    ", opens descriptions settings dialog":
      ", abre el diálogo de configuración de las descripciones",
    "captions settings": "configuración de leyendas",
    "subtitles settings": "configuración de subtítulos",
    "descriptions settings": "configuración de descripciones",
    Text: "Texto",
    White: "Blanco",
    Black: "Negro",
    Red: "Rojo",
    Green: "Verde",
    Blue: "Azul",
    Yellow: "Amarillo",
    Magenta: "Magenta",
    Cyan: "Cian",
    Background: "Fondo",
    Window: "Ventana",
    Transparent: "Transparente",
    "Semi-Transparent": "Semitransparente",
    Opaque: "Opaca",
    "Font Size": "Tamaño de fuente",
    "Text Edge Style": "Estilo de borde del texto",
    None: "Ninguno",
    Raised: "En relieve",
    Depressed: "Hundido",
    Uniform: "Uniforme",
    Dropshadow: "Sombra paralela",
    "Font Family": "Familia de fuente",
    "Proportional Sans-Serif": "Sans-Serif proporcional",
    "Monospace Sans-Serif": "Sans-Serif monoespacio",
    "Proportional Serif": "Serif proporcional",
    "Monospace Serif": "Serif monoespacio",
    Casual: "Informal",
    Script: "Cursiva",
    "Small Caps": "Minúsculas",
    Reset: "Restablecer",
    "restore all settings to the default values":
      "restablece todas las configuraciones a los valores predeterminados",
    Done: "Listo",
    "Caption Settings Dialog": "Diálogo de configuración de leyendas",
    "Beginning of dialog window. Escape will cancel and close the window.":
      "Comienzo de la ventana de diálogo. La tecla Escape cancelará la operación y cerrará la ventana.",
    "End of dialog window.": "Final de la ventana de diálogo.",
    "{1} is loading.": "{1} se está cargando.",
    "Exit Picture-in-Picture": "Salir de imagen sobre imagen",
    "Picture-in-Picture": "Imagen sobre imagen",
    "No content": "Sin contenido",
  },

  videoPlayerEn: {
    "Audio Player": "Audio Player",
    "Video Player": "Video Player",
    Play: "Play",
    Pause: "Pause",
    Replay: "Replay",
    "Current Time": "Current Time",
    Duration: "Duration",
    "Remaining Time": "Remaining Time",
    "Stream Type": "Stream Type",
    LIVE: "LIVE",
    "Seek to live, currently behind live":
      "Seek to live, currently behind live",
    "Seek to live, currently playing live":
      "Seek to live, currently playing live",
    Loaded: "Loaded",
    Progress: "Progress",
    "Progress Bar": "Progress Bar",
    "progress bar timing: currentTime={1} duration={2}": "{1} of {2}",
    Fullscreen: "Fullscreen",
    "Non-Fullscreen": "Exit Fullscreen",
    Mute: "Mute",
    Unmute: "Unmute",
    "Playback Rate": "Playback Rate",
    Subtitles: "Subtitles",
    "subtitles off": "subtitles off",
    Captions: "Captions",
    "captions off": "captions off",
    Chapters: "Chapters",
    Descriptions: "Descriptions",
    "descriptions off": "descriptions off",
    "Audio Track": "Audio Track",
    "Volume Level": "Volume Level",
    "You aborted the media playback": "You aborted the media playback",
    "A network error caused the media download to fail part-way.":
      "A network error caused the media download to fail part-way.",
    "The media could not be loaded, either because the server or network failed or because the format is not supported.":
      "The media could not be loaded, either because the server or network failed or because the format is not supported.",
    "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.":
      "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
    "No compatible source was found for this media.":
      "No compatible source was found for this media.",
    "The media is encrypted and we do not have the keys to decrypt it.":
      "The media is encrypted and we do not have the keys to decrypt it.",
    "Play Video": "Play Video",
    Close: "Close",
    "Close Modal Dialog": "Close Modal Dialog",
    "Modal Window": "Modal Window",
    "This is a modal window": "This is a modal window",
    "This modal can be closed by pressing the Escape key or activating the close button.":
      "This modal can be closed by pressing the Escape key or activating the close button.",
    ", opens captions settings dialog": ", opens captions settings dialog",
    ", opens subtitles settings dialog": ", opens subtitles settings dialog",
    ", opens descriptions settings dialog":
      ", opens descriptions settings dialog",
    ", selected": ", selected",
    "captions settings": "captions settings",
    "subtitles settings": "subtitles settings",
    "descriptions settings": "descriptions settings",
    Text: "Text",
    White: "White",
    Black: "Black",
    Red: "Red",
    Green: "Green",
    Blue: "Blue",
    Yellow: "Yellow",
    Magenta: "Magenta",
    Cyan: "Cyan",
    Background: "Background",
    Window: "Window",
    Transparent: "Transparent",
    "Semi-Transparent": "Semi-Transparent",
    Opaque: "Opaque",
    "Font Size": "Font Size",
    "Text Edge Style": "Text Edge Style",
    None: "None",
    Raised: "Raised",
    Depressed: "Depressed",
    Uniform: "Uniform",
    Dropshadow: "Dropshadow",
    "Font Family": "Font Family",
    "Proportional Sans-Serif": "Proportional Sans-Serif",
    "Monospace Sans-Serif": "Monospace Sans-Serif",
    "Proportional Serif": "Proportional Serif",
    "Monospace Serif": "Monospace Serif",
    Casual: "Casual",
    Script: "Script",
    "Small Caps": "Small Caps",
    Reset: "Reset",
    "restore all settings to the default values":
      "restore all settings to the default values",
    Done: "Done",
    "Caption Settings Dialog": "Caption Settings Dialog",
    "Beginning of dialog window. Escape will cancel and close the window.":
      "Beginning of dialog window. Escape will cancel and close the window.",
    "End of dialog window.": "End of dialog window.",
    "{1} is loading.": "{1} is loading.",
    "Exit Picture-in-Picture": "Exit Picture-in-Picture",
    "Picture-in-Picture": "Picture-in-Picture",
    "No content": "No content",
  },
};
